export enum Language {
  English = 'en',
  Czech = 'cz',
  Polish = 'pl'
}

export const LanguageToTtLang: Record<Language, number> = {
  [Language.English]: 1,
  [Language.Czech]: 0,
  [Language.Polish]: 4
};
